import { render, staticRenderFns } from "./lawRegisterPop.vue?vue&type=template&id=6bf956ba"
import script from "./lawRegisterPop.vue?vue&type=script&lang=js"
export * from "./lawRegisterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf956ba')) {
      api.createRecord('6bf956ba', component.options)
    } else {
      api.reload('6bf956ba', component.options)
    }
    module.hot.accept("./lawRegisterPop.vue?vue&type=template&id=6bf956ba", function () {
      api.rerender('6bf956ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/register/lawRegisterPop.vue"
export default component.exports